import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { cn } from '@/lib/styles'
import styles from '../featureComparison/FeatureCell.module.css'

export function BillingDetails({
	pricingItem,
	yearly = false,
	className,
}: {
	pricingItem?: Data.Component<'shared.pricing-plan-detail'> | null
	yearly?: boolean
	className?: string
}) {
	const t = useTranslations('Pricing')
	const price = yearly
		? (pricingItem?.priceBilledYearly ?? pricingItem?.priceBilledMonthly)
		: pricingItem?.priceBilledMonthly

	return (
		<div
			className={cn('flex flex-col gap-2.5 px-3.75 pb-5 text-neutral-light-100 h-full', className)}
		>
			{price != null && (
				<div className="lok-text-display-medium">
					{t('dollar')}
					{price}
					<span className="lok-text-heading-large">{t('mo')}</span>
				</div>
			)}

			{yearly && pricingItem?.priceUnderline ? (
				<div className="mt-auto">
					<CkEditorCSRRenderer
						htmlContent={pricingItem.priceUnderline}
						className={cn(styles['table-cell-content'], 'xl:whitespace-nowrap')}
						defaultTypography="bodyMedium"
					/>
				</div>
			) : null}
		</div>
	)
}
